import { motion } from "framer-motion";
import { useState } from "react";
import { DropZoneProps, DropZone as DropZoneRAC } from "react-aria-components";
import { cn } from "../../cn";

export default function DropZone(
  props: DropZoneProps & { children: React.ReactNode; isAnimating?: boolean },
) {
  const { isAnimating, ...restProps } = props;
  const [isHovered, setIsHovered] = useState(false);
  const shouldAnimate = isAnimating ?? isHovered;
  return (
    <DropZoneRAC
      {...restProps}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className={({ isDropTarget }) =>
        cn(
          "group h-full w-full rounded-7 p-4",
          isDropTarget && "border-3 border-blue bg-blue-light-1",
        )
      }
    >
      <svg
        className="absolute top-0 left-0 overflow-visible w-full h-full p-5 pointer-events-none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <linearGradient id="linear" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFD745" />
          <stop offset="50%" stopColor="#0097FF" />
          <stop offset="100%" stopColor="#FF39C6" />
        </linearGradient>
        <motion.rect
          className={cn(
            "stroke-grey-4",
            shouldAnimate && "stroke-[url(#linear)]",
            !isAnimating && "group-hover:stroke-[url(#linear)]",
          )}
          width="100%"
          height="100%"
          fill="none"
          rx="24"
          ry="24"
          strokeWidth="2"
          strokeDasharray="10"
          animate={{ strokeDashoffset: shouldAnimate ? [0, 100] : [0] }}
          transition={{
            repeat: Infinity,
            duration: 4,
            ease: "linear",
          }}
          strokeLinecap="square"
        />
      </svg>
      <div className="w-full h-full p-5 md:p-10">{props.children}</div>
    </DropZoneRAC>
  );
}
